import { TeamPointRankingEntry } from 'models/ranking/pointRanking/entry/TeamPointRankingEntry';

export class TeamPointRankingEntryService {
	toModel(ranking) {
		return new TeamPointRankingEntry(ranking);
	}
}
